import { useLocation, useParams } from 'react-router-dom';
import buildOrganizationAppsPath from '@/pages/microApps/helpers/buildOrganizationAppsPath';
import StaticCrumb from '../StaticCrumb';

const AppsCrumb = () => {
    const { agentId = '' } = useParams();
    const location = useLocation();
    const href = buildOrganizationAppsPath({ organizationId: agentId });
    const isListPage = location.pathname === href;

    return <StaticCrumb label="Apps" href={href} isCurrentPage={isListPage} />;
};

export default AppsCrumb;
